import { Sha256 } from '@aws-crypto/sha256-browser';
export async function sha256(value) {
    const hash = new Sha256();
    hash.update(value);
    return await hash.digest();
}
